// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"91fc1197","393":"6febad98","453":"e5bd56cd","638":"5380beca","764":"d9a411ae"}[chunkId] + ".chunk.js";
};